export default function Products() {
  const products = [
    {
      name: 'VPN',
      description: 'Secure your online privacy with military-grade encryption. Browse anonymously and access content from anywhere in the world.',
      icon: 'ri-shield-keyhole-line',
      image: 'https://public.readdy.ai/ai/img_res/46049de197e6035366709f34d2fd4b39.jpg',
      features: ['256-bit Encryption', 'Global Servers', 'No-Log Policy', 'Fast Connection']
    },
    {
      name: 'Cleaner',
      description: 'Optimize your device performance by removing junk files, managing storage, and boosting speed with intelligent cleaning algorithms.',
      icon: 'ri-brush-line',
      image: 'https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20interface%20showing%20storage%20optimization%20clean%20white%20UI%20design%20circular%20progress%20indicators%20file%20management%20system%20modern%20minimalist%20mobile%20app%20screenshot%20teal%20accent%20colors%20professional%20interface&width=400&height=500&seq=cleaner-product-001&orientation=portrait',
      features: ['Smart Cleaning', 'Storage Manager', 'Battery Optimizer', 'Photo Organizer']
    }
  ];

  return (
    <section id="products" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 border border-gray-200 rounded-full mb-6">
            <span className="text-gray-700 text-xs uppercase tracking-wider">Our Products</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">VPN & Cleaner Solutions</h2>
          <p className="text-gray-600 text-xl max-w-2xl mx-auto">
            Designed for security, performance, and seamless user experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start gap-6 mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-100 to-teal-100 rounded-2xl flex-shrink-0">
                  <i className={`${product.icon} text-3xl text-purple-600`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h3>
                  <p className="text-gray-600 leading-relaxed">{product.description}</p>
                </div>
              </div>

              <div className="mb-6">
                <img
                  src={product.image}
                  alt={`${product.name} app interface`}
                  className="w-full h-64 object-cover rounded-xl"
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                {product.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-lg"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}